
if (!customElements.get('lookbook-icon')) {
    customElements.define(
        'lookbook-icon',
        class LookbookIcon extends HTMLElement {
            constructor() {
                super();
                this.selectors = {
                    cardContainer: '.lookbook-card',
                    cardProduct: '.lookbook-card__product',
                    closeIcon: '.rocket-shop-the-look__lookbook-card__close-icon'
                };

                this.cardContainer = this.closest(this.selectors.cardContainer);
                this.cardProduct = this.querySelector(this.selectors.cardProduct);
                this.closeIcon = this.querySelector(this.selectors.closeIcon);

                this._onResize = this.updatePosition.bind(this);
                this._onMouseOver = this.handleMouseOver.bind(this);
                this._onClick = this.handleClick.bind(this);

                this.updatePosition();

                this.addEventListener('mouseover', this._onMouseOver);
                this.addEventListener('click', this._onClick);
                window.addEventListener('resize', this._onResize);

                if (this.closeIcon) {
                    this.closeIcon.addEventListener('click', (e) => {
                        e.stopPropagation();
                        this.cardProduct.classList.remove('is-active');
                    });
                }
            }

            disconnectedCallback() {
                this.removeEventListener('mouseover', this._onMouseOver);
                this.removeEventListener('click', this._onClick);
                window.removeEventListener('resize', this._onResize);
            }

            handleMouseOver() {
                if (this.cardProduct) {
                    this.closeAllOtherCards();
                    this.cardProduct.classList.add('is-active');
                    this.updatePosition();
                }
            }

            handleClick() {
                if (this.cardProduct) {
                    this.closeAllOtherCards();
                    this.cardProduct.classList.add('is-active');
                    this.updatePosition();
                }
            }

            closeAllOtherCards() {
                const allActiveCards = document.querySelectorAll('.lookbook-card__product.is-active');
                allActiveCards.forEach((card) => {
                    if (card !== this.cardProduct) {
                        card.classList.remove('is-active');
                    }
                });
            }

            updatePosition() {
                if (!this.cardProduct || !this.cardContainer) return;

                this.cardProduct.style.left = '';
                this.cardProduct.style.right = '';

                const containerRect = this.cardContainer.getBoundingClientRect();
                const hotspotRect = this.getBoundingClientRect();

                const containerWidth = this.cardContainer.clientWidth;
                const hotspotLeft = hotspotRect.left - containerRect.left;
                const cardWidth = this.cardProduct.offsetWidth;

                if (!cardWidth) return;

                const maxLeft = containerWidth - hotspotLeft - cardWidth;
                const minLeft = -hotspotLeft;

                let leftOffset;
                if (maxLeft >= 0) {
                    leftOffset = 0;
                } else {
                    leftOffset = Math.max(maxLeft, minLeft);
                }

                this.cardProduct.style.left = `${leftOffset}px`;
                this.cardProduct.style.right = 'auto';
            }
        }
    );
}
